export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Log masuk gagal, sila cuba lagi.",
  requestFailed: "Permintaan gagal, sila semak sambungan internet anda.",
  invalidLogin: "Nama Pengguna atau Kata Laluan Tidak Sah.",
  thisFunctionExists: "Fungsi ini sudah wujud.",
  thisFunctionNotAllowDelete: "Fungsi ini tidak dibenarkan untuk dipadamkan.",
  thisFunctionNotExists: "Fungsi ini tidak wujud.",
  targetFunctionIdRequired: "ID Fungsi Sasaran diperlukan.",
  thisPageExists: "Halaman ini sudah wujud.",
  thisPageNotAllowDelete: "Laman ini tidak dibenarkan untuk dipadamkan.",
  thisRoleExists: "Peranan ini sudah wujud.",
  thisRoleNotAllowDelete: "Peranan ini tidak dibenarkan untuk dipadamkan.",
  targetRoleIdRequired: "ID Peranan Sasaran diperlukan.",
  invalidParameter: "Parameter Tidak Sah.",
  systemError: "Sistem tidak dapat memproses permintaan anda.",
  spErrorMessage: "Ralat Mesej SP (Bergantung pada ralat).",
  actionbyRequired: "Pengguna semasa diperlukan.",
  sessionTokenRequired: "Token Sesi diperlukan.",
  functionIdRequired: "ID fungsi diperlukan.",
  functionNameRequired: "Nama fungsi diperlukan.",
  newFunctionNameRequired: "Nama fungsi diperlukan.",
  pageIdRequired: "ID Halaman diperlukan.",
  newPageIdRequired: "ID Halaman diperlukan.",
  newPageNameRequired: "Nama halaman diperlukan.",
  targetPageIdRequired: "ID Halaman Sasaran diperlukan.",
  passwordRequired: "Kata laluan diperlukan.",
  userNameRequired: "Nama Penuh diperlukan.",
  passwordValidation: "Kata laluan mestilah 6-20 aksara dan gabungan nombor dan huruf.",
  pageNumRequired: "Nombor Halaman diperlukan.",
  pageSizeRequired: "Saiz Halaman diperlukan.",
  roleIdRequired: "ID peranan diperlukan",
  oldPasswordRequired: "Kata Laluan Semasa diperlukan.",
  userStatusRequired: "Status Pengguna diperlukan.",
  newRoleIdRequired: "ID peranan diperlukan.",
  newRoleNameRequired: "Nama Peranan diperlukan.",
  startDateIsGteEndDate: "Tarikh Mula lebih besar daripada Tarikh Tamat.",
  thisRoleNotExists: "Peranan ini tidak wujud.",
  thisPageNotExists: "Halaman ini tidak wujud.",
  thisUserExists: "Pengguna ini sudah wujud.",
  thisUserNotExists: "Pengguna ini tidak wujud.",
  thisUserBlackListed: "Akaun anda telah digantung.",
  thisUserInactive: "Akaun anda telah dinyahdayakan.",
  thisUserBlocked: "Akaun anda telah disekat.",
  thisUserNotActive: "Akaun anda telah dinyahdayakan.",
  InvalidPageFunction: "Fungsi Halaman Tidak Sah.",
  invalidUser: "Pengguna Tidak Sah!",
  invalidToken: "Sesi Tidak Sah!",
  NoUserAccessRight: "Kebenaran ditolak!",
  connection: "Ralat Sambungan",
  profileIdRequired: "ID profil diperlukan.",
  packageIdRequired: "ID pakej diperlukan.",
  fullNameMinThreeChar: "Nama penuh mesti mempunyai sekurang-kurangnya 3 aksara.",
  accountIdMinThreeChar: "ID akaun mesti mempunyai sekurang-kurangnya 3 aksara.",
  searchCriteriaRequired: "Kriteria carian diperlukan.",
  affiliateIdRequired: "ID ejen diperlukan.",
  minDepositRequired: "Deposit Min diperlukan.",
  bonusRateRequired: "Kadar Bonus diperlukan.",
  onlyAllowRejectDeposit: "Hanya benarkan untuk menolak tiket deposit.",
  senderBankIdRequired: "ID bank pengirim diperlukan.",
  senderBankAccNoRequired: "Penghantar bank acc no. diperlukan.",
  minFTDAmtNumOnly: "Min. FTD Amt hanya menerima angka.",
  maxFTDAmtNumOnly: "Max. FTD Amt hanya menerima angka.",
  crmBasicCriteriaRequired: "ID Ahli / Telefon Hubungan / E-mel Hubungan / Tarikh Pendaftaran / Tarikh Log Masuk Terakhir diperlukan.",
  verifiedDateRangeAllowThreeMonths: "Julat tarikh pendaftaran hanya membenarkan pilih sehingga 3 bulan.",
  lastLoginDateRangeAllowThreeMonths: "Julat tarikh Log Masuk Terakhir hanya membenarkan pilih sehingga 3 bulan.",
  depositDateRangeAllowThreeMonths: "Julat tarikh deposit hanya membenarkan pilih sehingga 3 bulan.",
  ftdDateRangeAllowThreeMonths: "Julat tarikh FTD hanya membenarkan pilih sehingga 3 bulan.",
  ltdDateRangeAllowThreeMonths: "Julat tarikh LTD hanya membenarkan pilih sehingga 3 bulan.",
  lastLoginDateEarlierThanVerifiedDate: "Tarikh Log Masuk Terakhir lebih awal daripada tarikh pendaftaran.",
  depositDateEarlierThanVerifiedDate: "Tarikh deposit lebih awal daripada tarikh pendaftaran.",
  ftdDateEarlierThanVerifiedDate: "Tarikh FTD lebih awal daripada tarikh pendaftaran.",
  ltdDateEarlierThanVerifiedDate: "Tarikh LTD lebih awal daripada tarikh pendaftaran.",
  ftdFromRequired: "FTD dari tarikh diperlukan.",
  ftdToRequired: "FTD setakat ini diperlukan.",
  ltdFromRequired: "LTD dari tarikh diperlukan.",
  ltdToRequired: "LTD setakat ini diperlukan.",
  failedToLaunchPaymentGateway: "Gagal melancarkan gerbang pembayaran.",
  enTitleRequired: "Tajuk EN diperlukan.",
  enBodyRequired: "EN Badan diperlukan.",
  enImageUrlRequired: "Url Imej EN diperlukan.",
  enImageUrlDesktopRequired: "Url Imej Desktop EN diperlukan.",
  enAltRequired: "EN Alt diperlukan.",
  enHrefRequired: "EN Href diperlukan.",
  resubmitTicketRequired: "Hantar semula tiket diperlukan.",
  withtholdBonusAndAmountGreaterThanZero: "Penahanan bonus dan penahanan jumlah tidak boleh lebih besar daripada sifar pada masa yang sama.",
  maxWithdrawMultipleAndAmountGreaterThanZero: "Jumlah pengeluaran maksimum berbilang dan jumlah pengeluaran maksimum tidak boleh lebih besar daripada sifar pada masa yang sama.",
  serverBusy: "Pelayan sibuk sekarang. Sila cuba lagi.",
  isRequired: "Sila masukkan {fname}.",
  isMinValue: "{fname} mesti mempunyai minimum {fvalue}.",
  isMaxValue: "{fname} mestilah kurang daripada atau sama dengan {fvalue}.",
  isMinLength: "{fname} mesti mempunyai sekurang-kurangnya aksara {fvalue}.",
  isMaxLength: "{fname} mestilah kurang daripada atau sama dengan aksara {fvalue}.",
  isAlpha: "{fname} hanya menerima abjad.",
  isAlphaNum: "{fname} hanya menerima alfanumerik.",
  isNumeric: "{fname} hanya menerima angka.",
  isEmail: "{fname} hanya menerima alamat e-mel yang sah.",
  isIpAddress: "{fname} hanya menerima alamat IPv4 yang sah.",
  isSameAs: "{fname} mestilah sama dengan {fname2}.",
  isUrl: "{fname} hanya menerima URL.",
  containAlphaNum: "{fname} mesti mempunyai sekurang-kurangnya satu abjad dan satu nombor.",
  alphaNumWithSpace: "{fname} hanya menerima alfanumerik.",
  isDecimal: "{fname} hanya menerima angka.",
  isInteger: "{fname} menerima integer sahaja.",
  selectOption: "Sila pilih {fname}",
  notSameAs: "{fname} dan {fname2} tidak boleh sama.",
  dateRangeAllowOneMonth: "Julat tarikh hanya membenarkan pilih sehingga 1 bulan.",
  dateRangeAllowOneYear: "Julat tarikh hanya membenarkan pilih sehingga 1 tahun.",
  greaterThanZero: "{fname} mestilah lebih besar daripada sifar.",
  atLeastOneAuthority: "Mesti memilih sekurang-kurangnya satu pihak berkuasa.",
  BLOCK: "Akaun anda telah disekat.",
  SUSPEND: "Akaun anda telah digantung.",
  CLOSE: "Akaun anda telah ditutup.",
  RESETL: "Akaun anda telah ditetapkan semula.",
  atLeastOneProvider: "Mesti memilih sekurang-kurangnya satu pembekal.",
  failedToGetResultUrl: "Gagal mendapatkan url keputusan.",
  fileSizeValidation: "Terlalu besar, saiz maksimum yang dibenarkan ialah 1mb",
  atLeastOnePaymentOption: "Mesti memilih sekurang-kurangnya satu pilihan pembayaran.",
  atLeastOnePaymentGateway: "Mesti memilih sekurang-kurangnya satu gerbang pembayaran.",
  dateRangeAllow31Days: "Julat tarikh hanya membenarkan pilih sehingga 31 hari.",
  dateRangeAllow31Months: "Julat tarikh hanya membenarkan pilih sehingga 31 bulan.",
  dateRangeAllow31Years: "Julat tarikh hanya membenarkan pilih sehingga 31 tahun.",
  invalidCategory: "Kategori tidak sah.",
  noChanges: "Tiada perubahan.",
  permissionDenied: "Kebenaran ditolak.",
  referralCodeRequired: "Kod rujukan diperlukan.",
  providerDescRequired: "Penerangan pembekal diperlukan.",
  marqueeContentRequired: "Kandungan marquee diperlukan.",
  bonusNameRequired: "Nama bonus diperlukan.",
  baseAmountRequired: "Jumlah asas diperlukan.",
  reviewIdRequired: "ID semakan diperlukan.",
  surveyIdRequired: "ID tinjauan diperlukan.",
  questionRequired: "Soalan diperlukan.",
  iframeIdRequired: "ID iframe diperlukan.",
  bonusAmountRequired: "Jumlah bonus diperlukan.",
  inboxIdRequired: "ID peti masuk diperlukan.",
  exchangedAmountRequired: "Jumlah yang ditukar diperlukan.",
  baseRateRequired: "Kadar asas diperlukan.",
  exchangeRateRequired: "Kadar pertukaran diperlukan.",
  baseCurrencyRequired: "Mata wang asas diperlukan.",
  exchangeCurrencyRequired: "Pertukaran mata wang diperlukan.",
  depositTypeRequired: "Jenis deposit diperlukan.",
  nbRedepositRequired: "Deposit semula Nb diperlukan.",
  bankOwnerRequired: "Pemilik bank diperlukan.",
  autoSenderRequired: "Pengirim automatik diperlukan.",
  isRecommendRequired: "Adakah cadangan diperlukan.",
  recipientBankIdRequired: "ID bank penerima diperlukan.",
  recipientBankAccNoRequired: "Nombor akaun bank penerima diperlukan.",
  accountBalanceRequired: "Baki akaun diperlukan.",
  incomingAmountThresholdRequired: "Ambang amaun masuk diperlukan.",
  incomingFrequencyThresholdRequired: "Ambang frekuensi masuk diperlukan.",
  outgoingAmountThresholdRequired: "Ambang amaun keluar diperlukan.",
  outgoingFrequencyThresholdRequired: "Ambang frekuensi keluar diperlukan.",
  bankAccTypeRequired: "Jenis akaun bank diperlukan.",
  packageRequired: "Pakej diperlukan.",
  rtpRequired: "RTP diperlukan.",
  domainIdRequired: "ID domain diperlukan.",
  buyOnBehalfRequired: "Beli bagi pihak diperlukan.",
  serviceProviderRequired: "Pembekal perkhidmatan diperlukan.",
  serverAccountRequired: "Akaun pelayan diperlukan.",
  nameServerRequired: "Pelayan nama diperlukan.",
  socialLinkRequired: "Pautan sosial diperlukan.",
  newSocialPlatformRequired: "Platform sosial baharu diperlukan.",
  attachmentPathRequired: "Laluan lampiran diperlukan.",
  depositMethodRequired: "Kaedah deposit diperlukan.",
  depositDateRequired: "Tarikh deposit diperlukan.",
  refNoRequired: "Nombor rujukan diperlukan.",
  withdrawalAmountRequired: "Jumlah pengeluaran diperlukan.",
  targetBankAccNoRequired: "Nombor akaun bank sasaran diperlukan.",
  targetBankIdRequired: "ID bank sasaran diperlukan.",
  jsonRatingRequired: "Penarafan JSON diperlukan.",
  startTimeRequired: "Masa mula diperlukan.",
  accountIdRequired: "ID akaun diperlukan.",
  parentIdRequired: "ID ibu bapa diperlukan.",
  amountRequired: "Jumlah diperlukan.",
  clientIpRequired: "IP pelanggan diperlukan.",
  auditByRequired: "Audit oleh diperlukan.",
  systemTypeRequired: "Jenis sistem diperlukan.",
  currencyRequired: "Mata wang diperlukan.",
  ipAddressRequired: "Alamat IP diperlukan.",
  affiliateCodeRequired: "Kod ejen diperlukan.",
  contactPhoneRequired: "Telefon hubungan diperlukan.",
  requestTypeRequired: "Jenis permintaan diperlukan.",
  securityDisabledRequired: "Keselamatan dilumpuhkan diperlukan.",
  gameCodeRequired: "Kod permainan diperlukan.",
  seqRequired: "Urutan diperlukan.",
  minLimitRequired: "Had minimum diperlukan.",
  maxLimitRequired: "Had maksimum diperlukan.",
  commSportsRequired: "Komisen untuk sukan diperlukan.",
  commSlotsRequired: "Komisen untuk slot diperlukan.",
  commLivecasinoRequired: "Komisen untuk kasino langsung diperlukan.",
  commCockfightRequired: "Komisen untuk sabung ayam diperlukan.",
  commOthersRequired: "Komisen untuk orang lain diperlukan.",
  settingValueRequired: "Menetapkan nilai diperlukan.",
  vipIdRequired: "ID VIP diperlukan.",
  carryOverRequired: "Bawa diperlukan.",
  campaignIdRequired: "ID kempen diperlukan.",
  titleRequired: "Tajuk diperlukan.",
  bodyRequired: "Badan diperlukan.",
  itemOrderRequired: "Pesanan item diperlukan.",
  imageUrlRequired: "URL imej diperlukan.",
  bannerIdRequired: "ID sepanduk diperlukan.",
  directionRequired: "Arahan diperlukan.",
  defaultOrderRequired: "Pesanan lalai diperlukan.",
  altRequired: "Teks alt diperlukan.",
  hrefRequired: "Href diperlukan.",
  targetWindowRequired: "Tetingkap sasaran diperlukan.",
  loginRequiredRequired: "Log masuk diperlukan diperlukan.",
  activeFromRequired: "Aktif daripada diperlukan.",
  activeToRequired: "Aktif untuk diperlukan.",
  bannerTypeRequired: "Jenis sepanduk diperlukan.",
  pageNameRequired: "Nama halaman diperlukan.",
  remarkRequired: "Kenyataan diperlukan.",
  settingKeyRequired: "Kekunci tetapan diperlukan.",
  memberListRequired: "Senarai ahli diperlukan.",
  memberIdRequired: "ID Ahli diperlukan.",
  workingMonthRequired: "Bulan bekerja diperlukan.",
  workingDateRequired: "Tarikh bekerja diperlukan.",
  tacRequired: "Terma dan syarat diperlukan.",
  paymentModeRequired: "Mod pembayaran diperlukan.",
  newPasswordRequired: "Kata laluan baharu diperlukan.",
  loginIdRequired: "ID log masuk diperlukan.",
  securityTagRequired: "Tag keselamatan diperlukan.",
  securityCodeRequired: "Kod keselamatan diperlukan.",
  providerCodeRequired: "Kod pembekal diperlukan.",
  startDateRequired: "Tarikh mula diperlukan.",
  endDateRequired: "Tarikh tamat diperlukan.",
  searchIdRequired: "ID carian diperlukan.",
  authTokenRequired: "Token pengesahan diperlukan.",
  newStatusRequired: "Status baharu diperlukan.",
  actionRequired: "Tindakan diperlukan.",
  promotionIdRequired: "ID promosi diperlukan.",
  promotionNameRequired: "Nama promosi diperlukan.",
  rolloverRequired: "Peralihan diperlukan.",
  criteriaRequired: "Kriteria diperlukan.",
  ticketIdRequired: "ID tiket diperlukan.",
  resultIdRequired: "ID keputusan diperlukan.",
  bankIdRequired: "ID bank diperlukan.",
  bankAccNoRequired: "Nombor akaun bank diperlukan.",
  bankAccHolderRequired: "Pemegang akaun bank diperlukan.",
  newBankIdRequired: "ID bank baharu diperlukan.",
  newBankAccNoRequired: "Nombor akaun bank baharu diperlukan.",
  newBankAccHolderRequired: "Pemegang akaun bank baharu diperlukan.",
  fullNameRequired: "Nama penuh diperlukan.",
  depositAmountRequired: "Jumlah deposit diperlukan.",
  gatewayAccRequired: "Akaun pintu masuk diperlukan.",
  labelNameRequired: "Nama label diperlukan.",
  labelIdRequired: "ID label diperlukan.",
  bankTypeRequired: "Jenis bank diperlukan.",
  amountLimitRequired: "Had amaun diperlukan.",
  currencyRateRequired: "Kadar mata wang diperlukan.",
  urlRequired: "URL diperlukan.",
  cashRequired: "Wang tunai diperlukan.",
  csRequired: "Sokongan pelanggan diperlukan.",
  vipNameRequired: "Nama VIP diperlukan.",
  campaignNameRequired: "Nama kempen diperlukan.",
  transferIdRequired: "ID pemindahan diperlukan.",
  betTimeRequired: "Masa pertaruhan diperlukan.",
  turnoverRequired: "Perolehan diperlukan.",
  payoutRequired: "Pembayaran diperlukan.",
  winloseRequired: "Menang / Kalah diperlukan.",
  rawMessageRequired: "Mesej mentah diperlukan.",
  authStatusRequired: "Status pengesahan diperlukan.",
  dateRequired: "Tarikh diperlukan.",
  betIdRequired: "ID pertaruhan diperlukan.",
  betStatusRequired: "Status pertaruhan diperlukan.",
  betAmountRequired: "Jumlah pertaruhan diperlukan.",
  isParlayRequired: "Adakah parlay diperlukan.",
  isAddonRequired: "Adakah addon diperlukan.",
  withholdBonusRequired: "Bonus penahanan diperlukan.",
  withholdAmountRequired: "Jumlah penahanan diperlukan.",
  maxWithdrawAmountRequired: "Jumlah pengeluaran maksimum diperlukan.",
  betTypeRequired: "Jenis pertaruhan diperlukan.",
  maxWithdrawMultipleRequired: "Pengeluaran maksimum berbilang diperlukan.",
  socialPlatformRequired: "Platform sosial diperlukan.",
  vipProviderRebateRequired: "Rebat penyedia VIP diperlukan.",
  selfRebateRateRequired: "Kadar rebat sendiri diperlukan.",
  downlineRebateRateRequired: "Kadar rebat downline diperlukan.",
  tierIdRequired: "ID Peringkat diperlukan.",
  rebateRateRequired: "Kadar rebat diperlukan.",
  paymentGatewayRequired: "Gerbang pembayaran diperlukan.",
  rescueIdRequired: "ID penyelamat diperlukan.",
  rescueNameRequired: "Nama penyelamat diperlukan.",
  rescueCycleRequired: "Kitaran menyelamat diperlukan.",
  minLoseRequired: "Kerugian minimum diperlukan.",
  rescueRateRequired: "Kadar penyelamat diperlukan.",
  maxPayoutRequired: "Bayaran maksimum diperlukan.",
  payoutMethodRequired: "Kaedah pembayaran diperlukan.",
  targetGroupRequired: "Kumpulan sasaran diperlukan.",
  maintainDepositRequired: "Kekalkan deposit diperlukan.",
  maintainTurnoverRequired: "Kekalkan perolehan diperlukan.",
  depositOrTurnoverRequired: "Deposit atau perolehan diperlukan.",
  maintainDepositOrMaintainTurnoverRequired: "Mengekalkan deposit atau mengekalkan perolehan diperlukan.",
  vipListRequired: "Senarai VIP diperlukan.",
  gameNameRequired: "Nama permainan diperlukan.",
  claimTypeRequired: "Jenis tuntutan diperlukan.",
  operatorIdRequired: "ID pengendali diperlukan.",
  maxBonusRequired: "Bonus maksimum diperlukan.",
  endTimeRequired: "Masa tamat diperlukan.",
  mondayRequired: "Isnin diperlukan.",
  tuesdayRequired: "Selasa diperlukan.",
  wednesdayRequired: "Rabu diperlukan.",
  thursdayRequired: "Khamis diperlukan.",
  fridayRequired: "Jumaat diperlukan.",
  saturdayRequired: "Sabtu diperlukan.",
  sundayRequired: "Ahad diperlukan.",
  promotionTypeRequired: "Jenis promosi diperlukan.",
  claimLimitRequired: "Had tuntutan diperlukan.",
  bonusRate1Required: "Kadar bonus 1 diperlukan.",
  bonusRate1To2Required: "Kadar bonus 1 hingga 2 diperlukan.",
  bonusRate1To3Required: "Kadar bonus 1 hingga 3 diperlukan.",
  bonusRate1To4Required: "Kadar bonus 1 hingga 4 diperlukan.",
  bonusRate1To5Required: "Kadar bonus 1 hingga 5 diperlukan.",
  bonusRate1To6Required: "Kadar bonus 1 hingga 6 diperlukan.",
  bonusRate1To7Required: "Kadar bonus 1 hingga 7 diperlukan.",
  externalIdRequired: "ID luaran diperlukan.",
  opsiteRequired: "Opsite diperlukan.",
  opsiteContentRequired: "Kandungan opsite diperlukan.",
  opsiteLanguageRequired: "Bahasa opsite diperlukan.",
  opsitePaymentRequired: "Pembayaran opsite diperlukan.",
  opsiteProviderRequired: "Pembekal opsite diperlukan.",
  opsiteProviderGamesRequired: "Permainan pembekal opsite diperlukan.",
  accountTypeRequired: "Jenis akaun diperlukan.",
  domainNameRequired: "Nama domain diperlukan.",
  settledTimeRequired: "Masa yang diselesaikan diperlukan.",
  validTurnoverRequired: "Perolehan yang sah diperlukan.",
  resultTimeRequired: "Masa keputusan diperlukan.",
  resultStatusRequired: "Status keputusan diperlukan.",
  secondIdRequired: "ID kedua diperlukan.",
  domainListRequired: "Senarai domain diperlukan.",
  domainTypeRequired: "Jenis domain diperlukan.",
  moduleRequired: "Modul diperlukan.",
  gameIdRequired: "ID Permainan diperlukan.",
  gameDetailRequired: "Perincian permainan diperlukan.",
  bonusRate1To8Required: "Kadar bonus 1 hingga 8 diperlukan.",
  bonusRate1To9Required: "Kadar bonus 1 hingga 9 diperlukan.",
  bonusRate1To10Required: "Kadar bonus 1 hingga 10 diperlukan.",
  invalidOrder: "Pesanan tidak sah.",
  bannerNotExists: "Sepanduk tidak wujud.",
  invalidBannerType: "Jenis sepanduk tidak sah.",
  pageNameExists: "Nama halaman wujud.",
  pageNotExists: "Halaman tidak wujud.",
  tacIsValid: "OTP sah.",
  invalidTac: "OTP tidak sah.",
  tacExpired: "OTP tamat tempoh.",
  tacNotValidate: "OTP tidak disahkan.",
  paymentModeNotExists: "Mod pembayaran tidak wujud.",
  paymentOptionProviderNotExists: "Penyedia opsyen pembayaran tidak wujud.",
  ipAddressExists: "Alamat IP wujud.",
  ticketProcessed: "Tiket diproses.",
  bankAccountNotExists: "Akaun bank tidak wujud.",
  bankAccountInactive: "Akaun bank tidak aktif.",
  bankMemberNotExists: "Ahli bank tidak wujud.",
  bankMemberInactive: "Ahli bank tidak aktif.",
  affiliateExists: "Ejen wujud.",
  contactPhoneExists: "Telefon kenalan wujud.",
  affiliateFull: "Ejen penuh.",
  uplineInactive: "Upline tidak aktif.",
  applicationProcessed: "Permohonan diproses.",
  tacValidated: "Terma dan syarat disahkan.",
  applicationPending: "Permohonan belum selesai.",
  favouriteGameExists: "Permainan kegemaran wujud.",
  invalidLimit: "Had tidak sah.",
  settingNotSet: "Tetapan tidak ditetapkan.",
  domainNameNotExists: "Nama domain tidak wujud.",
  domainNameFull: "Nama domain penuh.",
  domainNameNotAvailable: "Nama domain tidak tersedia.",
  domainNameExists: "Nama domain wujud.",
  subAccountNotExists: "Sub-akaun tidak wujud.",
  settingNotExists: "Tetapan tidak wujud.",
  invalidContactEmail: "E-mel hubungan tidak sah.",
  accountInactive: "Akaun tidak aktif.",
  campaignNotExists: "Kempen tidak wujud.",
  paymentProviderNotExists: "Pembekal pembayaran tidak wujud.",
  profileInactive: "Profil tidak aktif.",
  minWithdrawalNotMet: "Pengeluaran minimum tidak dipenuhi.",
  invalidBankId: "ID bank tidak sah.",
  bankAccountExists: "Akaun bank wujud.",
  bankAccountFull: "Akaun bank penuh.",
  bankAccHolderNotSame: "Pemegang akaun bank tidak sama.",
  exceedMaxWithdrawal: "Melebihi pengeluaran maksimum.",
  exceedWithdrawalFrequency: "Melebihi kekerapan pengeluaran.",
  invalidPackage: "Pakej tidak sah.",
  promotionNotAvailable: "Promosi tidak tersedia.",
  ongoingPromotion: "Promosi berterusan.",
  pendingResultInGame: "Keputusan yang belum selesai dalam permainan.",
  labelNameExists: "Nama label wujud.",
  labelNotExists: "Label tidak wujud.",
  invalidFtdMin: "Minimum deposit kali pertama yang tidak sah.",
  invalidFtdMax: "Maksimum deposit kali pertama yang tidak sah.",
  ftdMinGtFtdMax: "Deposit kali pertama minimum lebih besar daripada maksimum.",
  vipFull: "VIP penuh.",
  invalidRewardType: "Jenis ganjaran tidak sah.",
  vipExists: "VIP wujud.",
  vipNotExists: "VIP tidak wujud.",
  onlyOneMaxWithdrawSetting: "Hanya satu tetapan pengeluaran maksimum dibenarkan.",
  onlyOneWithholdSetting: "Hanya satu tetapan penahanan dibenarkan.",
  campaignExists: "Kempen wujud.",
  vipProviderNotExists: "Pembekal VIP tidak wujud.",
  turnoverTierExists: "Peringkat perolehan wujud.",
  turnoverTierFull: "Peringkat perolehan melebihi peringkat maksimum.",
  turnoverTierNotExists: "Peringkat perolehan tidak wujud.",
  invalidSettingValue: "Nilai tetapan tidak sah.",
  turnoverTierNotSet: "Peringkat perolehan tidak ditetapkan.",
  rebateProcessed: "Rebat diproses.",
  invalidActionType: "Jenis tindakan tidak sah.",
  invalidRescueCycle: "Kitaran menyelamat tidak sah.",
  invalidPayoutMethod: "Kaedah pembayaran tidak sah.",
  invalidTargetGroup: "Kumpulan sasaran tidak sah.",
  rescueExists: "Penyelamatan wujud.",
  rescueNotExists: "Penyelamatan tidak wujud.",
  walletExists: "Dompet wujud.",
  accountExists: "Akaun wujud.",
  activeFromGtActiveTo: "Aktif daripada lebih besar daripada aktif ke.",
  accountNotExists: "ID pengendali tidak wujud.",
  invalidDeposit: "Deposit tidak sah.",
  invalidTurnover: "Perolehan tidak sah.",
  providerCodeNotExists: "Kod pembekal tidak wujud.",
  gameNameExists: "Nama permainan wujud.",
  gameNameNotExists: "Nama permainan tidak wujud.",
  invalidAccountType: "Jenis akaun tidak sah.",
  invalidLoginIdFormat: "Format ID log masuk tidak sah.",
  invalidReferralCode: "Kod rujukan tidak sah.",
  firstDepositNotMet: "Deposit pertama tidak dipenuhi.",
  newbieNotMet: "Keperluan pemula tidak dipenuhi.",
  claimPromoOnlyOnce: "Tuntut kenaikan pangkat sekali sahaja.",
  promotionRequirementNotMet: "Keperluan kenaikan pangkat tidak dipenuhi.",
  withdrawalAmountLteWithholdAmount: "Jumlah pengeluaran kurang daripada atau sama dengan jumlah penahanan.",
  subAccountInactive: "Sub-akaun tidak aktif.",
  gameNotSupported: "Permainan tidak disokong.",
  startTimeGteEndTime: "Masa mula lebih besar daripada atau sama dengan masa tamat.",
  invalidPromotionType: "Jenis promosi tidak sah.",
  invalidClaimType: "Jenis tuntutan tidak sah.",
  claimLimitExceeded10: "Had tuntutan melebihi 10.",
  verificationFailed: "Pengesahan gagal.",
  claimLimitReached: "Had tuntutan dicapai.",
  invalidPromotion: "Promosi tidak sah.",
  socialPlatformExists: "Platform sosial wujud.",
  duplicateReview: "Ulasan pendua.",
  invalidSurveyId: "ID tinjauan tidak sah.",
  accountNotBlock: "Akaun tidak disekat.",
  walletNotExists: "Dompet tidak wujud.",
  socialPlatformNotExists: "Platform sosial tidak wujud.",
  socialPlatformInactive: "Platform sosial tidak aktif.",
  accountSocialExists: "Akaun Sosial wujud.",
  invalidStatus: "Status tidak sah.",
  samePassword: "Kata laluan yang sama.",
  invalidPassword: "Nama Pengguna atau Kata Laluan Tidak Sah.",
  secondaryAccountExists: "Akaun sekunder wujud.",
  invalidSecurityCode: "Kod keselamatan tidak sah.",
  accountSocialNotExists: "Akaun sosial tidak wujud.",
  providerInactive: "Pembekal tidak aktif.",
  gameIdExists: "ID Permainan wujud.",
  gameIdNotExists: "ID Permainan tidak wujud.",
  parentProviderInactive: "Penyedia induk tidak aktif.",
  betLimitNotExists: "Had pertaruhan tidak wujud.",
  min3Characters: "Minimum 3 aksara.",
  invalidBankAccType: "Jenis akaun bank tidak sah.",
  senderBankNotExists: "Bank pengirim tidak wujud.",
  recipientBankNotExists: "Bank penerima tidak wujud.",
  affiliateNotExists: "Ejen tidak wujud.",
  redepositedTicket: "Tiket yang didepositkan semula.",
  invalidDepositType: "Jenis deposit tidak sah.",
  affiliateInactive: "Ejen tidak aktif.",
  bonusUnavailable: "Bonus tidak tersedia.",
  pendingDeposit: "Deposit belum selesai.",
  noOngoingPromotion: "Tiada kenaikan pangkat berterusan.",
  iframeNotExists: "IFrame tidak wujud.",
  gameMaintenance: "Penyelenggaraan permainan.",
  labelInactive: "Label tidak aktif.",
  invalidDomainType: "Jenis domain tidak sah.",
  invalidModule: "Modul tidak sah.",
  labelFull: "Label penuh.",
  questionExists: "Soalan wujud.",
  questionFull: "Soalan penuh.",
  questionNotExists: "Soalan tidak wujud.",
  reviewNotExists: "Ulasan tidak wujud.",
  invalidDomainGroup: "Kumpulan domain tidak sah.",
  invalidDateRange: "Julat tarikh tidak sah.",
  ipAddressNotExists: "Alamat IP tidak wujud.",
  marqueeNotExists: "Marquee tidak wujud.",
  invalidAmount: "Amaun tidak sah.",
  insufficientBalance: "Baki tidak mencukupi.",
  minLimitLtParent: "Had minimum kurang daripada ibu bapa.",
  maxLimitGtParent: "Had maksimum lebih besar daripada ibu bapa.",
  startDateGtEndDate: "Tarikh mula lebih besar daripada tarikh tamat.",
  currencyNotExists: "Mata wang tidak wujud.",
  currencyExists: "Mata wang wujud.",
  noAccumulateWin: "Tiada kemenangan terkumpul.",
  invalidSession: "Sesi tidak sah.",
  sessionExpired: "Sesi tamat tempoh.",
  promotionExists: "Promosi wujud.",
  invalidCriteria: "Kriteria tidak sah.",
  promotionNotExists: "Promosi tidak wujud.",
  ticketNotExists: "Tiket tidak wujud.",
  duplicateDebitRecord: "Rekod debit pendua.",
  duplicateCreditRecord: "Rekod kredit pendua.",
  debitRecordNotExists: "Rekod debit tidak wujud.",
  minDepositNotMet: "Deposit minimum tidak dipenuhi.",
  duplicateBet: "Pertaruhan pendua.",
  invalidProviderCode: "Kod pembekal tidak sah.",
  resultExists: "Keputusan wujud.",
  unableSPProcess: "Sistem tidak dapat memproses permintaan anda.",
  authRequired: "Kod pengesahan diperlukan.",
  domainExists: "Domain sudah wujud.",
  multiSelectOption: "Sila pilih {fname}",
  invalidDomainFormat: "Format Domain Tidak Sah",
  noHttpHttps: "'https://' atau 'http://' tidak dibenarkan.",
  noReservedSubdomain: "Subdomain terpelihara tidak dibenarkan. Untuk penggunaan pautan muat turun aplikasi.",
  operatorInactive: "Pengendali tidak aktif",
  invalidAccountIdFormat: "Format ID Akaun Tidak Sah",
  contentIdRequired: "ID Menu diperlukan",
  themeCodeRequired: "Kod tema diperlukan",
  themeNameRequired: "Nama tema diperlukan",
  themeColorRequired: "Warna tema diperlukan",
  languageRequired: "Bahasa diperlukan",
  positionRequired: "Kedudukan diperlukan",
  themeContentIdRequired: "ID kandungan tema diperlukan",
  emailRequired: "E-mel diperlukan",
  themeProviderTypeRequired: "Jenis pembekal tema diperlukan",
  phoneRequired: "Telefon diperlukan",
  targetTypeRequired: "Jenis sasaran diperlukan",
  packageTypeRequired: "Jenis pakej diperlukan",
  renewTermRequired: "Tempoh pembaharuan diperlukan",
  packagePriceRequired: "Harga pakej diperlukan",
  packageStatusRequired: "Status pakej diperlukan",
  sortKeyRequired: "Kekunci isihan diperlukan",
  invalidDomainStatus: "Status domain tidak sah",
  invalidCurrency: "Mata wang tidak sah",
  invalidThemeCode: "Kod tema tidak sah",
  invalidLanguage: "Bahasa tidak sah",
  invalidPosition: "Kedudukan tidak sah",
  invalidThemeContent: "Kandungan tema tidak sah",
  allParamsSameAsCurrent: "Tiada perubahan",
  invalidThemeColor: "Warna tema tidak sah",
  invalidCartStatus: "Status troli tidak sah",
  invalidThemeProviderType: "Jenis pembekal tema tidak sah",
  themeProviderTypeCannotBeUse: "Jenis pembekal tema tidak boleh digunakan",
  invalidUserStatus: "Status pengguna tidak sah",
  packageCannotBeRemove: "Pakej tidak boleh dikeluarkan",
  userStatusIsAlrdSuspend: "Pengguna sudah digantung",
  userStatusIsAlrdBlocked: "Pengguna sudah disekat",
  userStatusIsAlrdActive: "Pengguna sudah aktif",
  invalidSortType: "Jenis isihan tidak sah",
  startDateBiggerThanEndDate: "Tarikh mula lebih besar daripada tarikh tamat",
  positionCannotBeUse: "Kedudukan tidak boleh digunakan",
  funcAddContentFailed: "Gagal menambah kandungan",
  funcDeleteContentFailed: "Gagal memadamkan kandungan",
  funcUpdateContentFailed: "Gagal mengemas kini kandungan",
  funcAddThemeFailed: "Gagal menambah tema",
  funcDeleteThemeFailed: "Gagal memadam tema",
  funcUpdateThemeFailed: "Gagal mengemas kini tema",
  funcAddThemeColorFailed: "Gagal menambah warna tema",
  funcDeleteThemeColorFailed: "Gagal memadam warna tema",
  funcUpdateThemeColorFailed: "Gagal mengemas kini warna tema",
  funcAddLanguageFailed: "Gagal menambah bahasa",
  funcDeleteLanguageFailed: "Gagal memadamkan bahasa",
  funcUpdateLanguageFailed: "Gagal mengemas kini bahasa",
  funcAddThemeContentFailed: "Gagal menambah kandungan tema",
  funcDeleteThemeContentFailed: "Gagal memadam kandungan tema",
  funcUpdateThemeContentFailed: "Gagal mengemas kini kandungan tema",
  funcAddContentPositionFailed: "Gagal menambah kedudukan kandungan",
  funcUpdateContentPositionFailed: "Gagal mengemas kini kedudukan kandungan",
  funcDeleteContentPositionFailed: "Gagal memadamkan kedudukan kandungan",
  funcAddThemeProviderTypeFailed: "Gagal menambah jenis pembekal tema",
  funcUpdateThemeProviderTypeFailed: "Gagal mengemas kini jenis pembekal tema",
  funcDeleteThemeProviderTypeFailed: "Gagal memadam jenis pembekal tema",
  funcAddPackageFailed: "Gagal menambah pakej",
  funcUpdatePackageFailed: "Gagal mengemas kini pakej",
  funcDeletePackageFailed: "Gagal memadam pakej",
  nicknameRequired: "Nama panggilan diperlukan",
  accountStatusRequired: "Status akaun diperlukan",
  contentIdMaxLength50: "Panjang maksimum ID menu ialah 50",
  positionMaxLength10: "Panjang maksimum kedudukan ialah 10",
  contentDescMaxLength200: "Panjang maksimum perihalan kandungan ialah 200",
  domainStatusRequired: "Status domain diperlukan",
  funcAddDomainFailed: "Gagal menambah domain",
  funcUpdateDomainFailed: "Gagal mengemas kini domain",
  uploadFailed: "Muat naik gagal!",
  sortKeyMaxLength50: "Panjang maksimum kekunci isihan ialah 50",
  invalidSortTypeFormat: "Format jenis isihan tidak sah",
  invalidPackageId: "ID pakej tidak sah",
  invalidAccountStatusFormat: "Format status akaun tidak sah",
  invalidSiteStatusFormat: "Format status tapak yang tidak sah",
  invalidPackageStatus: "Status pakej tidak sah",
  invalidEmailFormat: "Format e-mel tidak sah",
  invalidPhoneFormat: "Format telefon tidak sah",
  languageLengthNotInRange: "Panjang bahasa tidak dalam julat (2-5)",
  languageDescriptionMaxLength50: "Panjang maksimum penerangan bahasa ialah 50",
  remarkMaxLength500: "Panjang maksimum komen ialah 500",
  themeProviderTypeMaxLength50: "Panjang maksimum jenis pembekal tema ialah 50",
  themeNameMaxLength50: "Panjang maksimum nama tema ialah 50",
  themeColorMaxLength20: "Panjang maksimum warna tema ialah 20",
  noSpace: "Tidak boleh mengandungi ruang",
  packageDescEnRequired: "Nama bahasa Inggeris diperlukan",
  packageDescEnMaxLength20: "Panjang maksimum Bahasa Inggeris nama ialah 20",
  allParamsIsNull: "Semua parameter adalah nol",
  contentCannotBeRemove: "Kandungan tidak boleh dialih keluar",
  contentDetailsRequired: "Butiran kandungan diperlukan",
  domainCannotBeUse: "Domain tidak boleh digunakan",
  domainGroupMaxLength20: "Panjang maksimum kumpulan domain ialah 20",
  domainGroupRequired: "Kumpulan domain diperlukan",
  domainNameCannotUpdate: "Nama domain tidak boleh dikemas kini",
  domainNameMaxLength400: "Panjang maksimum nama domain ialah 400",
  domainsRequired: "Domain diperlukan",
  domainStatusMaxLength20: "Panjang maksimum status domain ialah 20",
  domainTypeMaxLength10: "Panjang maksimum jenis domain ialah 10",
  funcAddThemeContentGroupFailed: "Tambah kumpulan kandungan tema gagal",
  funcDeleteThemeContentGroupFailed: "Padamkan kumpulan kandungan tema gagal",
  funcOpsiteUpdateFailed: "Kemas kini opsite gagal",
  funcResetAccountPasswordFailed: "Tetapkan semula kata laluan akaun gagal",
  funcSiteLanguageUpsertFailed: "Upsert bahasa tapak gagal",
  funcSiteThemeContentUpsertFailed: "Upsert kandungan tema laman gagal",
  funcSiteThemeUpsertFailed: "Upsert tema tapak gagal",
  funcSiteUpdateFailed: "Kemas kini tapak gagal",
  funcUpdateAccountFailed: "Kemas kini akaun gagal",
  funcUpdateAccountStatusActiveFailed: "Kemas kini status akaun kepada aktif gagal",
  funcUpdateAccountStatusCompanyBlockFailed: "Kemas kini status akaun kepada sekatan syarikat gagal",
  funcUpdateAccountStatusSuspendFailed: "Kemas kini status akaun untuk digantung gagal",
  funcUpdateThemeContentGroupFailed: "Kemas kini kumpulan kandungan tema gagal",
  invalidBoDomain: "Domain BO tidak sah",
  invalidOperatorIdFormat: "Format ID pengendali tidak sah",
  invalidOpsite: "Operasi tidak sah",
  invalidOpsiteOperator: "Pengendali operasi tidak sah",
  invalidOpsiteVersion: "Versi opsite tidak sah",
  invalidParentContentInGroup: "Kandungan induk tidak sah dalam kumpulan",
  invalidSite: "Laman web tidak sah",
  invalidSiteStatus: "Status tapak tidak sah",
  invalidThemeContentGroup: "Kumpulan kandungan tema tidak sah",
  languageCannotBeUse: "Bahasa tidak boleh digunakan",
  languagesRequired: "Bahasa diperlukan",
  logo1Required: "Logo diperlukan",
  notSupportMultiDefault: "Berbilang lalai tidak disokong",
  operatorIdMaxLength50: "Panjang maksimum ID pengendali ialah 50",
  opsiteNotMatch: "Opsite tidak sepadan",
  packageTypeMaxLength15: "Panjang maksimum jenis pakej ialah 15",
  parentContentIdCannotSameWithContentId: "ID kandungan induk tidak boleh sama dengan ID kandungan",
  phoneNumberRequired: "Nombor telefon diperlukan",
  siteIdRequired: "ID Tapak diperlukan",
  siteNameMaxLength50: "Panjang maksimum nama tapak ialah 50",
  siteNameRequired: "Nama tapak diperlukan",
  technicalError: "Ralat teknikal",
  themeCannotBeRemove: "Tema tidak boleh dikeluarkan",
  themeCodeCannotBeUse: "Kod tema tidak boleh digunakan",
  themeCodeMaxLength20: "Panjang maksimum kod tema ialah 20",
  themeColorCannotBeRemove: "Warna tema tidak boleh dikeluarkan",
  themeColorCannotBeUse: "Warna tema tidak boleh digunakan",
  themeContentCannotBeUse: "Kandungan tema tidak boleh digunakan",
  themeContentGroupCannotBeUse: "Kumpulan kandungan tema tidak boleh digunakan",
  themeContentGroupDescriptionMaxLength50: "Panjang maksimum perihalan kumpulan kandungan tema ialah 50",
  themeContentGroupMaxLength20: "Panjang maksimum kumpulan kandungan tema ialah 20",
  themeContentGroupRequired: "Kumpulan kandungan tema diperlukan",
  themeNameCannotBeUse: "Nama tema tidak boleh digunakan",
  userHaventVerifyThisBefore: "Pengguna belum mengesahkan ini sebelum ini",
  isDefaultTrueRequired: "Bahasa mesti mempunyai 1 lalai",
  accountIdMaxLength50: "Panjang maksimum ID pengguna ialah 50",
  headBodyScriptEitherOne: "Sila masukkan Skrip Kepala atau Skrip Badan",
  alphaOrNum: "Mestilah abjad atau nombor sahaja",
  phoneValid: "Sila masukkan Nombor Telefon yang sah",
  permittedAmountRequired: "Jumlah yang dibenarkan diperlukan",
  ignoreRiskRequired: "Abaikan risiko diperlukan",
  paymentDescRequired: "Penerangan pembayaran diperlukan",
  gameTypeRequired: "Jenis permainan diperlukan",
  statusRequired: "Status diperlukan",
  payoutIdRequired: "Id Pembayaran diperlukan",
  commNotExists: "Suruhanjaya tidak wujud",
  parentCommNotExists: "Suruhanjaya induk tidak wujud",
  carryOverNotExists: "Carry over tidak wujud",
  hotGameExists: "Permainan panas sudah wujud",
  commSportsExceededParent: "Suruhanjaya untuk sukan melebihi ibu bapa",
  commSlotsExceededParent: "Komisen untuk slot melebihi induk",
  commLivecasinoExceededParent: "Komisen untuk kasino langsung melebihi ibu bapa",
  commCockfightExceededParent: "Suruhanjaya untuk sabung ayam melebihi ibu bapa",
  commOthersExceededParent: "Komisen untuk orang lain melebihi ibu bapa",
  hotGameNotExists: "Permainan panas tidak wujud",
  noSecurityDeposit: "Tiada dana keselamatan",
  exchangeRateNotExists: "Kadar pertukaran tidak wujud",
  insufficientSecurityDeposit: "Dana keselamatan yang tidak mencukupi",
  duplicateDomain: "Domain pendua",
  contactEmailNotExists: "E-mel hubungan tidak wujud",
  featuredGameNotExists: "Permainan ciri tidak wujud",
  newGameNotExists: "Permainan baru tidak wujud",
  popularGameNotExists: "Permainan popular tidak wujud",
  featuredGameExists: "Permainan ciri sudah wujud",
  newGameExists: "Permainan baru sudah wujud",
  popularGameExists: "Permainan popular sudah wujud",
  rebateNotExists: "Rebat tidak wujud",
  riskyMember: "Ahli berisiko",
  ipRestricted: "IP terhad",
  notSupportedBank: "Bank tidak disokong.",
  requestTooFrequent: "Permintaan terlalu kerap.",
  paymentOptionNotExists: "Opsyen Pembayaran tidak wujud.",
  earningIdRequired: "Memperoleh ID diperlukan.",
  ptOnRequired: "PT diperlukan.",
  ptRequired: "PT diperlukan.",
  userIdRequired: "ID Pengguna diperlukan.",
  businessIdRequired: "ID Perniagaan diperlukan.",
  subAccountIdRequired: "ID Sub Akaun diperlukan.",
  sourceAccountIdRequired: "ID Akaun Sumber diperlukan.",
  targetAccountIdRequired: "ID Akaun Sasaran diperlukan.",
  ticketTaken: "Tiket diambil",
  ticketNotTaken: "Tiket tidak diambil",
  invalidPt: "PT Tidak Sah",
  topupIdRequired: "ID tambah nilai diperlukan",
  promotionMemberLogNotExists: "log ahli promosi tidak wujud",
  paymentOptionInactive: "Pilihan Pembayaran Tidak Aktif",
  invalidCartStatusFormat: "Format status troli tidak sah",
  requestIncompleted: "Permintaan Tidak Lengkap",
  unknownError: "Ralat tidak diketahui berlaku",
  cartIdRequired: "ID troli diperlukan",
  stepNameRequired: "Nama langkah diperlukan",
  invalidCart: "Troli tidak sah",
  invalidStepName: "Nama langkah tidak sah",
  cartHaventSetupComplete: "Troli belum selesai persediaan",
  funcCartCreateFailed: "Gagal mencipta troli",
  funcCartUpdateFailed: "Gagal mengemas kini troli",
  funcSiteCreateFailed: "Gagal membuat laman web",
  funcCartPurchasedUpdateFailed: "Gagal mengemas kini troli yang dibeli",
  invalidPasswordFormat: "Format kata laluan tidak sah",
  currencyCodeRequired: "Mata wang diperlukan",
  funcCartLanguageUpsertFailed: "Upsert Bahasa Troli Fungsi Gagal",
  invalidUserIdFormat: "Format ID Pengguna Tidak Sah",
  operatorPasswordRequired: "Kata Laluan Pengendali diperlukan",
  funcCartOperatorInfoUpsertFailed: "Maklumat Pengendali Troli Fungsi Upsert Gagal",
  invalidOperatorPasswordFormat: "Format Kata Laluan Pengendali Tidak Sah",
  operatorIdCannotBeUse: "ID Pengendali tidak boleh digunakan",
  siteNameLengthNotInRange: "Panjang Nama Tapak tidak dalam julat",
  userIdCannotBeUse: "ID Pengguna tidak boleh digunakan",
  siteIdAlrdExist: "ID Laman sudah wujud",
  operatorIdAlrdExist: "ID pengendali sudah wujud",
  externalIdAlrdExist: "ID luaran sudah wujud",
  opsiteContentAlrdExist: "Kandungan tema kandungan laman web sudah wujud",
  opsiteLanguageAlrdExist: "Bahasa kandungan laman web sudah wujud",
  boAccountAlrdExist: "Akaun BO sudah wujud",
  boAccountProfileAlrdExist: "Profil akaun BO sudah wujud",
  boAccountLoginAlrdExist: "Log masuk akaun BO sudah wujud",
  funcCartThemeCodeUpsertFailed: "Gagal menaikkan tema troli",
  funcCartThemeColorUpsertFailed: "Gagal menaikkan warna troli",
  funcOpsiteCreateFailed: "Gagal mencipta kandungan laman web",
  alphabetValid: "Mesti mempunyai sekurang-kurangnya satu huruf besar dan huruf kecil",
  numberValid: "Mesti mempunyai sekurang-kurangnya satu nombor",
  symbolValid: "Mesti mempunyai sekurang-kurangnya satu simbol",
  credentialNotSet: "Kelayakan tidak ditetapkan",
  validBankAccFormat: "Acc Bank Tidak Sah No. Format",
  moreThan: "{fname} mestilah kurang daripada atau sama dengan {fname2}",
  lessThan: "{fname} mestilah lebih daripada atau sama dengan {fname2}.",
  bankAccountNotAvailable: "Akaun bank tidak tersedia.",
  insufficientCredit: "Kredit Tidak Mencukupi",
  enableRequired: "Dayakan diperlukan.",
  funcAddGameFailed: "Gagal menambah permainan.",
  funcAddGameRewardByBatchFailed: "Gagal menambah ganjaran permainan mengikut kelompok.",
  funcAddGameRewardFailed: "Gagal menambah ganjaran permainan.",
  funcAddGameTemplateFailed: "Gagal menambah templat permainan.",
  funcAddLayoutTemplateFailed: "Gagal menambah templat susun atur.",
  funcAddOperatorGameFailed: "Gagal menambah permainan pengendali.",
  funcAddOperatorMemberWalletFailed: "Gagal menambah dompet ahli pengendali.",
  funcDeleteGameFailed: "Gagal memadamkan permainan.",
  funcDeleteGameRewardFailed: "Gagal memadamkan ganjaran permainan.",
  funcDeleteGameTemplateFailed: "Gagal memadamkan templat permainan.",
  funcDeleteLayoutTemplateFailed: "Gagal memadamkan templat susun atur.",
  funcDeleteOperatorGameFailed: "Gagal memadamkan permainan pengendali.",
  funcUpdateGameFailed: "Gagal mengemas kini permainan.",
  funcUpdateGameRewardFailed: "Gagal mengemas kini ganjaran permainan.",
  funcUpdateGameTemplateFailed: "Gagal mengemas kini templat permainan.",
  funcUpdateLayoutTemplateFailed: "Gagal mengemas kini templat susun atur.",
  funcUpdateOperatorGameFailed: "Gagal mengemas kini permainan pengendali.",
  gameCannotBeRemove: "Permainan tidak boleh dikeluarkan.",
  gameNameCannotBeUse: "Nama permainan tidak boleh digunakan.",
  gameNameMaxLength150: "Nama permainan mestilah paling banyak 150 aksara.",
  gameRewardCannotBeUse: "Ganjaran permainan tidak boleh digunakan.",
  gameRewardLimitExceeded: "Had ganjaran permainan melebihi.",
  gameTemplateExist: "Templat permainan sudah wujud.",
  gameTypeMaxLength20: "Jenis permainan mestilah paling banyak 20 aksara.",
  invalidGame: "Permainan tidak sah.",
  invalidGameReward: "Ganjaran permainan tidak sah.",
  invalidGameTemplate: "Templat permainan tidak sah.",
  invalidMemberWallet: "Dompet ahli tidak sah.",
  invalidOperatorGame: "Permainan pengendali tidak sah.",
  invalidRewardProbability: "Kebarangkalian ganjaran tidak sah.",
  invalidTemplate: "Templat tidak sah.",
  maxGameRewardRequired: "Ganjaran permainan maksimum diperlukan.",
  maxMiniGameRewardRequired: "Ganjaran permainan mini maksimum diperlukan.",
  memberWalletAlrdExist: "Dompet ahli sudah wujud.",
  operatorGameCannotBeUse: "Permainan pengendali tidak boleh digunakan.",
  operatorGameIdRequired: "ID permainan pengendali diperlukan.",
  rewardCodeMaxLength20: "Kod ganjaran mestilah paling banyak 20 aksara.",
  rewardCodeRequired: "Kod ganjaran diperlukan.",
  rewardCurrencyMaxLength5: "Mata wang ganjaran mestilah paling banyak 5 aksara.",
  rewardCurrencyRequired: "Mata wang ganjaran diperlukan.",
  rewardDescriptionMaxLength100: "Penerangan ganjaran mestilah paling banyak 100 aksara.",
  rewardNameMaxLength50: "Nama ganjaran mestilah paling banyak 50 aksara.",
  rewardProbabilityRequired: "Kebarangkalian ganjaran diperlukan.",
  rewardRequired: "Ganjaran diperlukan.",
  selectedTemplateMaxLength30: "Templat yang dipilih mestilah paling banyak 30 aksara.",
  selectedTemplateRequired: "Templat terpilih diperlukan.",
  success: "Kejayaan.",
  templateCannotBeRemove: "Templat tidak boleh dialih keluar.",
  templateCodeCannotBeUse: "Kod templat tidak boleh digunakan.",
  templateCodeMaxLength30: "Kod templat mestilah paling banyak 30 aksara.",
  templateCodeRequired: "Kod templat diperlukan.",
  templateNameMaxLength50: "Nama templat mestilah paling banyak 50 aksara.",
  tokenRequestRequired: "Permintaan token diperlukan.",
  tokenRequired: "Token diperlukan.",
  mustMoreThan: "{fname} mestilah lebih daripada {fvalue}",
  mustMoreThanOrEqual: "{fname} mestilah lebih daripada atau sama dengan {fvalue}",
  tokenInvalid: "Input token tidak sah pada {key}",
  cashInvalid: "Input tunai tidak sah pada {key}",
  atLeastOneRequired: "Sekurang-kurangnya satu diperlukan",
  cash1To7Required: "Tunai 1 hingga 7 diperlukan",
  cash1To6Required: "Tunai 1 hingga 6 diperlukan",
  cash1To5Required: "Tunai 1 hingga 5 diperlukan",
  cash1To4Required: "Tunai 1 hingga 4 diperlukan",
  cash1To3Required: "Tunai 1 hingga 3 diperlukan",
  cash1To2Required: "Tunai 1 hingga 2 diperlukan",
  cash1Required: "Tunai 1 diperlukan",
  token1To7Required: "Token 1 hingga 7 diperlukan",
  token1To6Required: "Token 1 hingga 6 diperlukan",
  token1To5Required: "Token 1 hingga 5 diperlukan",
  token1To4Required: "Token 1 hingga 4 diperlukan",
  token1To3Required: "Token 1 hingga 3 diperlukan",
  token1To2Required: "Token 1 hingga 2 diperlukan",
  token1Required: "Token 1 diperlukan",
  cycleRequired: "Kitaran diperlukan",
  targetAmountRequired: "Jumlah sasaran diperlukan",
  gamifyIdRequired: "ID ganjaran diperlukan",
  gamifyMemberProcessed: "Ahli ganjaran diproses",
  gamifyNotExists: "Ganjaran tidak wujud",
  gamifyInactive: "Ganjaran tidak aktif",
  invalidCycle: "Kitaran Tidak Sah",
  memberIdMaxLength50: "ID Ahli tidak boleh melebihi 50 aksara",
  funcAddGameWalletFreeCreditFailed: "Gagal menambah kredit percuma ke dompet permainan",
  funcUpdateOperatorMemberWalletBalanceFailed: "Gagal mengemas kini baki dompet ahli pengendali",
  funcUpdateOperatorMemberWalletBalanceByFrozenFailed: "Gagal mengemas kini baki dompet ahli pengendali mengikut jumlah beku",
  mustHaveBothAlphaNumOnly: "Gunakan abjad dan nombor sahaja, dengan sekurang-kurangnya satu daripada setiap satu.",
  setupGameRewardBeforeEnable: "Sila sediakan ganjaran permainan sebelum mendayakannya.",
  rewardProbabilityMustNotAllZero: "Kebarangkalian ganjaran tidak boleh semua sifar.",
  totalRewardProbabilityCannotOver100: "Jumlah kebarangkalian ganjaran tidak boleh melebihi 100.",
  credential1To2Required: "Kelayakan 1 hingga 2 diperlukan.",
  credential1To4Required: "Kelayakan 1 hingga 4 diperlukan.",
  newRemarkRequired: "Kenyataan diperlukan.",
  notSupportedWithdrawalPG: "Gerbang pembayaran pengeluaran yang tidak disokong.",
  prizeInvalid: "Input hadiah tidak sah di {key}",
  exceedMaxCampaignCount: "Melebihi bilangan maksimum kempen papan pendahulu.",
  leaderboardCampaignEnded: "Kempen papan pendahulu telah tamat.",
  leaderboardCampaignStarted: "Kempen papan pendahulu bermula",
  leaderboardCampaignSettled: "Kempen papan pendahulu selesai",
  pleaseSelectUpToNoPhone: "Sila pilih sehingga {fname} nombor telefon.",
  phoneNotAvailable: "Telefon tidak tersedia.",
  batchExpired: "Kumpulan telah tamat tempoh.",
  remarkNotSame: "Catatan tidak sepadan",
  partnerIdRequired: "ID rakan kongsi diperlukan",
  partnerNotExists: "Rakan kongsi tidak wujud",
  urgencyRequired: "Tahap segera diperlukan",
  groupSizeRequired: "Saiz kumpulan diperlukan",
  inactiveDaysRequired: "Hari tidak aktif diperlukan",
  idRequired: "ID diperlukan",
  expiryRequired: "Tarikh tamat diperlukan",
  batchIdRequired: "ID kelompok diperlukan",
  requestDateRequired: "Tarikh permintaan diperlukan",
  requestByRequired: "Pemohon diperlukan",
  cpiIdRequired: "ID CPI diperlukan",
  assigneeRequired: "Penerima tugasan diperlukan",
  phoneNotAvailable: "Telefon tidak tersedia",
  liveChatNotExists: "Sembang langsung tidak wujud",
  resultNotExists: "Keputusan tidak wujud",
  lastLaunchFundTransfer: "Pemindahan dana pelancaran terakhir",
  alreadyRegistered: "Sudah berdaftar",
  invalidId: "ID tidak sah",
  batchExpired: "Kelompok telah tamat tempoh",
  teleCalling: "Panggilan telefon",
  invalidUrgency: "Tahap segera tidak sah",
  appTypeRequired: "Jenis aplikasi diperlukan",
  invalidAppType: "Jenis aplikasi tidak sah",
  appLinkRequired: "Pautan aplikasi diperlukan",
  invalidDomain: "Domain tidak sah",
  existEndDateGtEndDate: "Tarikh tamat sedia ada lebih lewat daripada tarikh tamat baharu",
  newRemark2Required: "Catatan 2 baharu diperlukan",
  remark2NotSame: "Catatan 2 tidak sepadan",
  remark2Required: "Catatan 2 diperlukan",
  nameRequired: "Nama diperlukan",
  aiAssistantNotExists: "Pembantu AI tidak wujud",
  aiAssistantInactive: "Pembantu AI tidak aktif",
  phoneStartWithVND: "Nombor telefon mesti bermula dengan 84",
  otherActiveLiveChat: "Terdapat LiveChat lain yang aktif",
  whiteLabelRequired: "White Label diperlukan",
  invalidWhiteLabel: "White Label tidak sah",
  baseRateDepositRequired: "Kadar asas deposit diperlukan",
  revisionRequired: "Semakan diperlukan",
  typeDescRequired: "Penerangan jenis diperlukan",
  riskWeightRequired: "Berat risiko diperlukan",
  linkageTypeRequired: "Jenis pautan diperlukan",
  valueRequired: "Nilai diperlukan",
  baseRateWithdrawalRequired: "Kadar asas pengeluaran diperlukan",
  sourceIdRequired: "ID sumber diperlukan",
  targetIdRequired: "ID sasaran diperlukan",
  linkageTypeNotExists: "Jenis pautan tidak wujud",
  phoneStartWithMYR: "Nombor telefon mesti bermula dengan 60",
  minWithdrawalAmount100: "Jumlah pengeluaran minimum ialah 100",
  invalidReward: "Ganjaran tidak sah",
  noRow: "Tiada baris",
  credentialRequired: "Kredensial diperlukan",
  settlementIdRequired: "ID Settlement diperlukan",
  settlementDateRequired: "Tarikh settlement diperlukan",
  newCryptoAddressRequired: "Alamat kripto baharu diperlukan",
  cryptoAddressRequired: "Alamat kripto diperlukan",
  settlementTypeRequired: "Jenis settlement diperlukan",
  chatProviderRequired: "Penyedia chat diperlukan",
  countRequired: "Bilangan diperlukan",
  voucherCodeRequired: "Kod baucar diperlukan",
  eventTypeRequired: "Jenis event diperlukan",
  viewTypeRequired: "Jenis paparan diperlukan",
  actionTypeRequired: "Jenis tindakan diperlukan",
  thresholdRequired: "Ambang diperlukan",
  missionIdRequired: "ID misi diperlukan",
  ruleIdRequired: "ID peraturan diperlukan",
  aggregatorRequired: "Aggregator diperlukan",
  rebateIdRequired: "ID rebate diperlukan",
  liveChatExists: "Livechat sudah wujud",
  triggerNotExists: "Trigger tidak wujud",
  missionRuleNotExists: "Peraturan misi tidak wujud",
  invalidVoucherCode: "Kod baucar tidak sah",
  invalidRebateType: "Jenis rebate tidak sah",
  invalidSettlementType: "Jenis settlement tidak sah",
  missionNotExists: "Misi tidak wujud",
  settlementTypeNotExists: "Jenis settlement tidak wujud",
  parentTriggerInactive: "Trigger induk tidak aktif",
  parentMissionInactive: "Misi induk tidak aktif",
  missionRuleNotSet: "Peraturan misi belum ditetapkan",
  invalidCreditType: "Jenis kredit tidak sah",
  cryptoDisabled: "Kripto telah dinyahaktifkan",
  depositExists: "Deposit sudah wujud",
  parentSettlementTypeNotExists: "Jenis settlement induk tidak wujud",
  accessControlNotExists: "Kawalan akses tidak wujud",
  cryptoAccountFull: "Akaun kripto penuh",
  cryptoAccountExists: "Akaun kripto sudah wujud",
  cryptoAccountNotExists: "Akaun kripto tidak wujud",
  settlementNotAvailable: "Settlement tidak tersedia",
  settlementProcessed: "Settlement telah diproses",
  cryptoAccountInactive: "Akaun kripto tidak aktif",
  leadIdRequired: "ID lead diperlukan",
  failedToCreateFreeRound: "Gagal mencipta free round.",
  failedToGetFreeRound: "Gagal mendapatkan free round.",
  failedToGetFreeRoundGameList: "Gagal mendapatkan senarai permainan free round.",
  tierFull: "Tahap Penuh",
  tierNotExists: "Tahap tidak wujud",
  ticketTypeRequired: "Jenis Tiket diperlukan",
  invalidTicketType: "Jenis Tiket tidak sah",
  positionRequired: "Kedudukan diperlukan",
  invalidPosition: "Kedudukan tidak sah",
  invalidBonusRate: "Kadar Bonus tidak sah",
  minRequired: "Nilai minimum diperlukan",
  maxRequired: "Nilai maksimum diperlukan",
  minGtMax: "Nilai minimum lebih besar daripada maksimum.",
  sessionExists: "Sesi telah wujud",
  sessionOverlaps: "Sesi bertindih",
  sessionIdRequired: "ID Sesi diperlukan",
  sessionNotExists: "Sesi tidak wujud",
  nameExists: "Nama telah wujud",
  sessionElapsed: "Sesi telah tamat",
  validUrl: "Sila masukkan URL yang sah",
  minBalanceNotMet: "Baki minimum tidak dipenuhi",
  validSlugFormat: "Format slug tidak sah",

  failedToCancelFreeRound: "Gagal membatalkan pusingan percuma.",
  failedToGetFreeRoundLineBet: "Gagal mendapatkan pertaruhan baris pusingan percuma.",
};